import LayoutBasic from "@/views/layouts/LayoutBasic";
import UsersSalary from "@/views/users/Salary";
import UsersList from "@/views/users/List";
import UsersManagers from "@/views/users/Managers";
import RunnersList from "@/views/users/Runners";
import WorkShifts from "@/views/users/Shifts";
import MTelegram from "@/views/users/TelegramMessage";
import UsersSalaryProspects from '@/views/users/SalaryProspects';
import AgentsList from '@/views/users/agents/List.vue';
import AgentsGroup from '@/views/users/agents/Group.vue';
import EmptyLayout from "@/views/layouts/EmptyLayout.vue";
import ManagersGroups from "@/views/users/ManagersGroups.vue";
import ManagersGroupsHistory from "@/views/users/ManagersGroupsHistory.vue";
import ManagersShiftsActivation from "@/views/users/managers/ShiftActivation.vue";


const routes = {
  path: '/users',
  component: LayoutBasic, // Change the desired Layout here,
  meta: {requiresAuth: true},
  children: [
    {
      path: 'salary',
      component: UsersSalary,
      name: 'UsersSalary',
      meta: {
        // allowedTo: [ROLES.ID.SuperAdmin],
        permission: 'users/salary'
      }
    },
    {
      path: 'salaryp',
      component: UsersSalaryProspects,
      name: 'UsersSalaryProspects',
      meta: {
        // allowedTo: [ROLES.ID.SuperAdmin],
        permission: 'users/salaryp'
      }
    },
    {
      path: 'list',
      component: UsersList,
      name: 'UsersList',
      meta: {
        permission: 'users/list'
      }
    },
    {
      path: 'managers',
      component: UsersManagers,
      name: 'UsersManagers',
      meta: {
        permission: 'users/managers'
      }
    },
    {
      path: 'managers/groups',
      component: ManagersGroups,
      name: 'UsersManagersGroups',
      meta: {
        permission: 'users/managers/groups'
      }
    },
    {
      path: 'managers/shifts',
      component: ManagersShiftsActivation,
      name: 'ManagersShiftsActivation',
      meta: {
        permission: 'users/managers/shifts'
      }
    },
    {
      path: 'managers/groups/history',
      component: ManagersGroupsHistory,
      name: 'UsersManagersGroupsHistory',
      meta: {
        permission: 'users/managers/groups/history'
      }
    },
    {
      path: 'runners',
      component: RunnersList,
      name: 'RunnersList',
      meta: {
        permission: 'users/runners'
      }
    },
    {
      path: 'shifts',
      component: WorkShifts,
      name: 'WorkShifts',
      meta: {
        permission: 'users/shifts'
      }
    },
    {
      path: 'mtelegram',
      component: MTelegram,
      name: 'MTelegram',
      meta: {
        permission: 'users/mtelegram'
      }
    },
    {
      path: 'agents',
      component: EmptyLayout,
      meta: {requiresAuth: true},
      children: [
        {
          path: 'list',
          component: AgentsList,
          name: 'UsersAgentsList',
          meta: {
            permission: 'users/agents/list'
          }
        },
        {
          path: 'group',
          component: AgentsGroup,
          name: 'UsersAgentsGroup',
          meta: {
            permission: 'users/agents/group'
          }
        },
      ]
    },
  ]
}

export default routes;
